import { mutate } from "swr";
import Auth from "../Auth";

export const INSTALLATIONS_LIST_KEY = "/api/installations/list";

const BASE_FETCH_OPTIONS = {
  responseReadFailureRetries: 2,
  responseReadFailureRetryDelayMs: 250,
};

// Installations payloads are large (~2MB). Avoid focus/reconnect/mount churn and
// dedupe repeated reads across the many components that subscribe to this key.
export const INSTALLATIONS_LIST_SWR_OPTIONS = {
  keepPreviousData: true,
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  dedupingInterval: 600_000,
};

let installationsListInflight = null;

async function loadInstalledPluginsList(requestSource, onFetched) {
  if (!installationsListInflight) {
    installationsListInflight = (async () => {
      const data = await Auth.fetchWithIdToken(INSTALLATIONS_LIST_KEY, {}, null, {
        ...BASE_FETCH_OPTIONS,
        requestSource,
      });
      const installations = data.installations;
      await seedInstalledPluginsCache(installations);
      return installations;
    })().finally(() => {
      installationsListInflight = null;
    });
  }

  const installations = await installationsListInflight;
  onFetched?.(installations);
  return installations;
}

export function createInstalledPluginsFetcher({ requestSource, onFetched } = {}) {
  return () => loadInstalledPluginsList(requestSource, onFetched);
}

export function seedInstalledPluginsCache(installations) {
  return mutate(INSTALLATIONS_LIST_KEY, installations, { revalidate: false });
}

export async function fetchInstalledPluginsList(requestSource) {
  return loadInstalledPluginsList(requestSource);
}
